module.exports = __webpack_public_path__ + "assets/hoppa.png?18790f8434c825af33b1f1bcc20c6c3c";